import $ from 'jquery';

const agentUrl = 'https://script.google.com/macros/s/AKfycbxSy5dOV5BiQsUxTuMBSmHfhRpwXLnV7bC7vWmPaNaao_VrZw/exec';
const guarantorUrl = 'https://script.google.com/macros/s/AKfycbyO4surgGeCgOBuREtqGG72e2z_wXNkvZeSV5Bsbb-W5rxYcPQ/exec';


export const formSubmitAction = async (params) => {

    const { isUrl, data } = params;

    if(isUrl === 'agent') {

        const response =  $.ajax({
            url: agentUrl,
            method: 'POST',
            dataType: 'json',
            data,
        })

    return await response;

    }else if(isUrl === 'guarantor') {

        const response =  $.ajax({
            url: guarantorUrl,
            method: 'POST',
            dataType: 'json',
            data,
        })

    return await response;

    }
}